import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  ResponsiveContainer,
  ComposedChart,
  XAxis,
  YAxis,
  Area,
  Tooltip,
  Label,
} from "recharts";
import { useTranslation } from "react-i18next";

const CustomTooltip = ({ active, payload, label }) => {
  return active ? (
    <div>
      <p>
        <strong>{`${dayjs(label).format("YYYY-MM-DD HH:mm:ss")}`}</strong>
      </p>
      <p>
        <strong>Heap: </strong>
        {`${payload !== undefined ? payload?.[0]?.value?.toFixed(2) : ""} GB`}
      </p>
      <p>
        <strong>CPU: </strong>
        {`${payload !== undefined ? payload?.[1]?.value?.toFixed(2) : ""} %`}
      </p>
    </div>
  ) : (
    <Fragment />
  );
};

const ChartDisplay = () => {
  const { t } = useTranslation();
  const { clusterData } = useSelector((state) => state.data);
        // const  = {
        //     "totalIn": 0,
        //     "processorCount": 4,
        //     "nonCooperativeTaskCount": 1,
        //     "cpuUsageSeries": {
        //         "series": [
        //             "0.00",
        //             "0.00",
        //             "0.00"
        //         ],
        //         "startTs": 1705900067338,
        //         "interval": 1000
        //     },
        //     "heapTotal": "3.88",
        //     "version": "4.2",
        //     "taskCount": 4,
        //     "restEnabled": false,
        //     "clusterTime": 1705900070324,
        //     "heapUsage": "0.05",
        //     "nodeCount": 1,
        //     "jobCount": 1,
        //     "clusterState": "ACTIVE",
        //     "totalOut": 0,
        //     "heapUsageSeries": {
        //         "series": [
        //             "0.00",
        //             "0.00",
        //             "0.00"
        //         ],
        //         "startTs": 1705900067338,
        //         "interval": 1000
        //     }
        // }
  const heapUsageSeries = clusterData?.heapUsageSeries;
  const cpuUsageSeries = clusterData?.cpuUsageSeries;
  const tick = [...Array(300).keys()].map(
    (val, index) => heapUsageSeries?.startTs + index * 1000
  );

    const data = heapUsageSeries?.series.map((value, index) => ({
        heap: Number(value),
        cpu: Number(cpuUsageSeries.series[index]),
        time: tick[index],
    }));
    return (
        <Fragment>
            <ResponsiveContainer>
                <ComposedChart
                    data={data}
                    margin={{ top: 40, right: 10, bottom: -10, left: 15 }}
                >
                    <XAxis
                        dataKey={"time"}
                        tickFormatter={(val) => dayjs(val).format("HH:mm:ss")}
                    />
                    <YAxis
                        dataKey={"heap"}
                        yAxisId={"left"}
                        orientation={"left"}
                        tickFormatter={(val) => `${val} GB`}
                    >
                        <Label
                            value={t("heapUsage")}
                            offset={-10}
                            position='insideLeft'
                            angle={-90}
                            style={{ textAnchor: "middle" }}
                        />
                    </YAxis>
                    <YAxis
                        dataKey={"cpu"}
                        yAxisId={"right"}
                        orientation={"right"}
                        tickFormatter={(val) => `${val} %`}
                    >
                        <Label
                            value={t("cpuUsage")}
                            offset={60}
                            position='insideLeft'
                            angle={90}
                            style={{ textAnchor: "middle" }}
                        />
                    </YAxis>
                    <Tooltip content={<CustomTooltip />} />
                    <Area
                        dataKey={"heap"}
                        yAxisId={"left"}
                        type={"natural"}
                        fill={"pink"}
                        fillOpacity={0.3}
                        stroke={"pink"}
                    />
                    <Area
                        dataKey={"cpu"}
                        yAxisId={"right"}
                        type={"monotone"}
                        fill={"lightGreen"}
                        fillOpacity={0.3}
                        stroke={"lightGreen"}
                    />
                </ComposedChart>
            </ResponsiveContainer>
        </Fragment>
    );
};

export default ChartDisplay;
